import {createAsyncThunk} from '@reduxjs/toolkit';
import type {AddTeamMembersDialogData} from '@Panels/add-team-members-panel/add-team-members-panel.types';

export const getAddTeamMembersDialogData = createAsyncThunk<AddTeamMembersDialogData>('addTeamMembersPanel/getDialogData', async () => {
    return (await window.PMW.readLocal('teams/getAddTeamMembersDialogData')) as AddTeamMembersDialogData;
});
